import './Project/globals';

import 'object-fit-videos';
import 'vanilla-lazyload';
import 'lazyembed2';
import 'jquery';
import 'isotope-layout';

/**
 * Ruby Mega Menu
 */
import './Vendor/Ruby/ie10-viewport-bug-workaround';
import './Vendor/Ruby/ruby-main';

/**
 * Bootstrap
 */
import 'bootstrap/js/src/util';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/tooltip';
//import 'bootstrap/js/src/popover';

/**
 * Bootstrap Select
 */
import 'bootstrap-select';

/**
 * Slick
 */
import 'slick-carousel';

/**
 * Light Galery
 */
import 'lightgallery';
//import 'lg-autoplay';
//import 'lg-fullscreen';
//import 'lg-hash';
//import 'lg-pager';
//import 'lg-share';
//import 'lg-thumbnail';
//import 'lg-video';
//import 'lg-zoom';

/**
 * Project
 */
import './Project/Viewport';
import './Project/SizeChanged';
import './Project/PageLoadedQueue';
import './Project/objectFitVideos';
import './Project/counter';
import './Project/circleCounter';
import './Project/lightGallery';
import './Project/lazyload';
import './Project/lazyEmbed';
import './Project/slick';
import './Project/tables';
import './Project/tooltip';
import './Project/select';

import '../../../../../Avency.Sprehe.Career/Resources/Private/Fusion/Component/Molecule/CareerOfferTeaser/CareerOfferTeaser';
import '../../../../../Avency.Sprehe.Products/Resources/Private/Fusion/Component/Molecule/ProductSlider/ProductSlider';

